/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import React from "react";
import { GlobeAltIcon } from "@heroicons/react/24/outline";
import { Service } from "@/api/services";
import { SERVICE_ICONS } from "@/constants/serviceIcons";

interface ServiceIconProps {
  service: Service;
  className?: string;
}

// Resolves a service's configured icon (preset brand icon, custom image URL,
// or a generic globe fallback).
export const ServiceIcon: React.FC<ServiceIconProps> = ({ service, className = "h-5 w-5 text-gray-700 dark:text-gray-300" }) => {
  const preset = service.iconType === "preset" && service.iconValue
    ? SERVICE_ICONS[service.iconValue]
    : undefined;

  if (preset) {
    return <preset.Icon className={className} />;
  }

  if (service.iconType === "url" && service.iconValue) {
    return (
      <img
        src={service.iconValue}
        alt=""
        className={`${className} object-contain`}
        onError={(e) => {
          (e.target as HTMLImageElement).style.display = "none";
        }}
      />
    );
  }

  return <GlobeAltIcon className={className} />;
};
